// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Yc-z","heading":"Zc-z","items":"_c-z","featureCss":"ad-z","disabled":"bd-z","imgCss":"cd-z"};